import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function GetDailyTrafficFlowData(condition = {}) {
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi GetDailyTrafficFlowData: time is null')
    return
  }

  let response = {}
  let startTime = moment(condition.startTime).startOf('day').format().split('+')[0] //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let encodeStartTime = encodeURIComponent(startTime)
  let endTime = moment().startOf('day').isSame(moment(condition.endTime).format(), 'day') ?
    moment().format().split('+')[0] : moment(condition.endTime).endOf('day').format().split('+')[0] // 結束時間是今天，則endTime是現在時間，否則是選擇日期的endOf('day')
  let encodeEndTime = encodeURIComponent(endTime)
  let timeQuery = `?startTime=${encodeStartTime}&endTime=${encodeEndTime}`
  let roadEntranceQuery = (condition.roadEntranceId && condition.roadEntranceId !== -1) ? `&roadEntranceId=${condition.roadEntranceId}` : ''
  let typeQuery = (condition.vehicleType && condition.vehicleType !== -1) ? `&type=${condition.vehicleType}` : ''

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Traffic/GetDailyTrafficFlowData${timeQuery}${roadEntranceQuery}${typeQuery}`)

  } catch (err) {
    console.error('iisi getTrafficFlowData: ', err)
    response.data = []
  }

  Utils.setApiResponsSuccess(response)
  response.data = response.data.sort((a, b) => {
    return b.startTime.localeCompare(a.startTime)
  })

  return response
}

export async function GetAllTrafficFlowData(condition = {}) {
  let response = {}
  let endTime = moment().format().split('+')[0] // 現在時間  //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let encodeEndTime = encodeURIComponent(endTime)
  let endTimeQuery = `?endTime=${encodeEndTime}`

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Traffic/GetAllTrafficFlowData${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetAllTrafficFlowData: ', err)
    response.data = {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}